import React from 'react';
import { METRIKA_GOALS, reachGoal } from '../analytics';

const MAX_CHANNEL_URL =
  'https://max.ru/join/pai31kNDfQCJk9YR70Yc6iYs1LVh2Jcn5rey-d7I6lA';

const DIAGNOSTICS_URL = 'https://school.glotov.pro/diagnostika';
const META_VSTRECHA_URL = 'https://school.glotov.pro/meta-vstrecha';
const CORPORATE_AI_URL = '/ai/#corporate-contact';

const EMAIL = 'aleksey@glotov.pro';

const MAILTO_URL = `mailto:${EMAIL}?subject=${encodeURIComponent(
  'Запрос с сайта glotov.pro'
)}&body=${encodeURIComponent(
  'Здравствуйте, Алексей!\n\nКоротко обо мне и моей задаче:\n'
)}`;

const TELEGRAM_DM_URL = `https://t.me/aleksglotov?text=${encodeURIComponent(
  'Здравствуйте, Алексей! Пишу с glotov.pro. Коротко о моей задаче: '
)}`;

function Contacts() {
  return (
    <section id="contacts" className="contacts-section">
      <div className="contacts-panel">
        <div>
          <p className="eyebrow">Следующий шаг</p>
          <h2>Выберите подходящий способ начать</h2>
          <p>
            Для самостоятельного старта пройдите диагностику. Для личной
            работы запишитесь на первую встречу. Корпоративный запрос по ИИ
            начнём с бесплатной предварительной встречи на 20–30 минут.
          </p>
          <div className="contact-direct">
            <span>Связаться напрямую</span>
            <div className="contact-direct-links">
              <a href={TELEGRAM_DM_URL} target="_blank" rel="noopener noreferrer">
                Telegram
              </a>
              <a href={MAILTO_URL}>{EMAIL}</a>
              <a href="https://t.me/glotov_pro" target="_blank" rel="noopener noreferrer">
                Telegram-канал
              </a>
              <a href={MAX_CHANNEL_URL} target="_blank" rel="noopener noreferrer">
                MAX
              </a>
            </div>
          </div>
        </div>
        <div className="contact-links">
          <a
            className="contact-link contact-link-primary"
            href={DIAGNOSTICS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
            onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
          >
            <span className="contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" />
                <path d="m9 13 2 2 9-9" />
              </svg>
            </span>
            <span className="contact-label">
              Пройти диагностику
              <small>бесплатно · открытый материал</small>
            </span>
          </a>
          <a
            className="contact-link contact-link-accent"
            href={META_VSTRECHA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-metrika-goal={METRIKA_GOALS.SELECT_PERSONAL}
            onClick={() => reachGoal(METRIKA_GOALS.SELECT_PERSONAL)}
          >
            <span className="contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="5" width="18" height="16" rx="2" />
                <path d="M8 3v4M16 3v4M3 11h18" />
              </svg>
            </span>
            <span className="contact-label">
              Начать персональную работу
              <small>первая встреча · 3 000 ₽</small>
            </span>
          </a>
          <a
            className="contact-link"
            href={CORPORATE_AI_URL}
            data-metrika-goal={METRIKA_GOALS.SELECT_AI}
            onClick={() => reachGoal(METRIKA_GOALS.SELECT_AI)}
          >
            <span className="contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5" y="5" width="14" height="14" rx="2" />
                <path d="M9 9h6v6H9zM9 2v3m6-3v3M9 19v3m6-3v3M2 9h3m-3 6h3m14-6h3m-3 6h3" />
              </svg>
            </span>
            <span className="contact-label">
              Обсудить внедрение ИИ
              <small>бесплатная встреча · 20–30 минут</small>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contacts;
